import ServiceBase from './ServiceBase';

import { convertArrayParamsToCommaSeparatedList } from '@/Utils/FiltersUtility';

export default class OrdersService extends ServiceBase {

    getUserPledges(projectID) {
        return this.$http.get('orders/getUserPledges', { params: { projectID } });
    }

    removeUnpaidOrderItems(orderID) {
        const params = {
            orderID,
        };

        return this.$http.post('orders/removeUnpaidOrderItems', params);
    }

    getManageShippingOrderDetails(model) {
        const params = {
            applyCartShippingChanges: model.applyCartShippingChanges,
            appliedGiftCardIDs: model.appliedGiftCardIDs,
            orderCode: model.orderCode,
            projectID: model.projectID,
        };
        return this.$http.get('orders/getManageShippingOrderDetails', {
            params: convertArrayParamsToCommaSeparatedList(params),
        });
    }

    getAwaitingPaymentOrderDetails(model) {
        const params = {
            appliedGiftCardIDs: model.appliedGiftCardIDs,
            orderCode: model.orderCode,
            projectID: model.projectID,
        };
        return this.$http.get('orders/getAwaitingPaymentOrderDetails', {
            params: convertArrayParamsToCommaSeparatedList(params),
        });
    }

    getOrderDetails(model) {
        const params = {
            appliedGiftCardIDs: model.appliedGiftCardIDs,
            orderCode: model.orderCode,
            projectID: model.projectID,
        };
        return this.$http.get('orders/getOrderDetails', {
            params: convertArrayParamsToCommaSeparatedList(params),
        });
    }

    validateOrderItems(model) {
        // validation scopes left undefined are omitted from the query and validated by default
        const params = {
            orderCode: model.orderCode,
            projectID: model.projectID,
            validateOptions: model.validateOptions,
            validateQuantity: model.validateQuantity,
            validateRestrictedLocation: model.validateRestrictedLocation,
            validateLockedOptions: model.validateLockedOptions,
        };
        return this.$http.get('orders/validateOrderItems', { params });
    }

    abortCartPayment(orderCode, projectID) {
        const params = {
            orderCode,
            projectID,
        };
        return this.$http.post('orders/abortCartPayment', params);
    }

    abortPayment(orderCode, projectID) {
        const params = {
            orderCode,
            projectID,
        };

        return this.$http.post('orders/abortPayment', params);
    }

    getOrderStageHistory(orderID) {
        const params = {
            orderID,
        };

        return this.$http.get('orders/GetOrderStageHistory', { params });
    }
}
